import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { memo } from "react";
import PropTypes from "prop-types";
import { Text } from "sprout-ui-primitives";
import { formatToReact } from "sprout-lib/dist/parser";
const StyledText = styled(Text)`
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-wrap: break-word;

  font-size: 14px;
  line-height: 20px;

  margin-top: 8px;
`;
function CommentText(props) {
    const { text  } = props;
    return /*#__PURE__*/ _jsx(StyledText, {
        children: formatToReact(text, "SIMPLE")
    });
}
CommentText.propTypes = {
    text: PropTypes.string.isRequired
};
export default /*#__PURE__*/ memo(CommentText);
